import translations, { availableLanguages, defaultLanguage } from '../languages/i18n';

// ASPECTE GRÀFIC
export const bgColor = '#e6ffff'; // Color de fons body
export const mainColor = '#ccffff'; // Color principal
export const complementaryColor = '#00bcd4'; // Color complementari al principal

export const greenColor = '#4caf50'; 
export const amberColor = '#ffc107';
export const redColor = '#f44336';
export const orangeColor = '#ff7400';

export const minimWidth = 1024; // Amplada mínima de la pantalla, si la finestra es fa més petita surt barra d'scroll
export const maximWidth = 1400; // Amplada màxima de la pantalla, si la finestra es fa més grossa surten espais buits als costats
export const spinnerLoadingColor = '#ffffff'; // Color de l'indicador de càrrega circular
export const spinnerLoadingSize = 80; // Mida de l'indicador de càrrega circular. Per defecte és 40
export const feedbackDuration = 6000; // Temps en milisegons durant el que es mostren els missatges de feedback
export const minimWidthBasicButton = 150; // Mida mínima dels botons creats amb el component basicButton

// FORMULARIS
export const heightUnits = 'cm'; // Etiqueta de les unitats en que s'ha d'indicar l'alçada
export const passwordMinimumLength = 6; // ATENCIÓ: pensa a canviar el missatge ('_passwordMinimumLength') si modifiques el valor (actualment és 6) i comprovar que coincideix amb el valor del servidor
export const weightUnits = 'Kg'; // Etiqueta de les unitats en que s'ha d'indicar el pes
export const extraDays = 1; // Dies que s'afegeixen als daysToFillIn dels formularis. Normalment serà 1 per així tenir en compte el dia en curs a l'hora de mostrar els dies que falten per a que caduqui un formulari

// LLISTES i TAULES
export const defaultRowsPerPage = 10; // ATENCIÓ: en modificar aquesta constant, modificar l'array rowsPerPageOptions per a que no s'hi repeteixi el valor
export const maxItems = 5; // Nombre màxim d'elements a mostrar abans d'afegir "..." (utilitzat, per exemple, en mostrar la llista de membres d'un equip)
export const rowsPerPageOptions = [5, defaultRowsPerPage, 25, { label: translations['_all'], value: -1 }]; // Opcions per als menú desplegables per a la paginació del contingut de les taules
export const programTypes = [{ value: 'cs', description: 'CS' }, { value: 'ichom', description: 'ICHOM' }, { value: 'other', description: 'OTHER' }, { value: 'diabetext', description: 'DIABETEXT' }]; // ATENCIÓ: Al primer objecte posar-hi el valor per defecte. Opcions per al selects per triar el tipus de programa. Comprovar que siguin els mateixos tipus que al programSchema (program.js)
export const clinicianRoles = [{ value: 'none', description: '' }, { value: 'normal', description: translations['_normal'] }, { value: 'admin', description: translations['_responsible'] }]; // ATENCIÓ: Al primer objecte posar-hi el valor per defecte. Opcions per al selects per triar el tipus de usuari clinic.
export const defaultSortOrder = 'asc'; // Indica l'ordre per defecte en que s'ordenen les llistes pot ser ascendent ('asc') o descendent ('desc')

// MAPES PELS BREADCRUMBS
const initialLanguage = translations.getLanguage();
const breadcrumbNameMapObjArray = availableLanguages.map((lang) => {
  translations.setLanguage(lang);
  const breadcrumbNameMap = {
    [lang]: {
      admin: {
        // '/admin': translations['_home'],
        '/admin/clinicianInfo': translations['_info'],
        '/admin/editClinicianInfo': translations['_editInfo'],
        '/admin/listClinicians': translations['_list'],
        '/admin/clinicianSchedulesInfo': translations['_forms'],
        '/admin/newClinicianInfo': translations['_new'],
        '/admin/listPrograms': translations['_list'],
        '/admin/editProgramInfo': translations['_editInfo'],
        '/admin/newProgramInfo': translations['_new'],
        '/admin/patientInfo': translations['_info'],
        '/admin/editPatientInfo': translations['_editInfo'],
        '/admin/listPatients': translations['_list'],
        '/admin/patientSchedulesInfo': translations['_forms'],
        '/admin/newPatientInfo': translations['_new'],
        '/admin/editEnrolmentInfo': translations['_infoEnrolment'],
        '/admin/formInfo': translations['_infoForm'],
      },
      clinician: {
        // '/clinician': translations['_home'],
        '/clinician/clinicianInfo': translations['_info'],
        '/clinician/editClinicianInfo': translations['_editInfo'],
        '/clinician/listClinicians': translations['_list'],
        '/clinician/clinicianSchedulesInfo': translations['_forms'],
        '/clinician/newClinicianInfo': translations['_new'],
        '/clinician/listPrograms': translations['_list'],
        '/clinician/editProgramInfo': translations['_editInfo'],
        '/clinician/newProgramInfo': translations['_new'],
        '/clinician/patientInfo': translations['_info'],
        '/clinician/editPatientInfo': translations['_editInfo'],
        '/clinician/listPatients': translations['_list'],
        '/clinician/patientSchedulesInfo': translations['_forms'],
        '/clinician/newPatientInfo': translations['_new'],
        '/clinician/editEnrolmentInfo': translations['_infoEnrolment'],
        '/clinician/formInfo': translations['_infoForm'],
        '/clinician/mySchedulesInfoClinician': translations['_list'],
      },
      patient: {
        // '/clinician': translations['_home'],
        '/patient/listPatientForms': translations['_list'],
        '/patient/formInfo': translations['_infoForm'],
      },
    },
  };
  return breadcrumbNameMap;
});
// Tornam a l'idioma inicial
translations.setLanguage(initialLanguage || defaultLanguage);
// Convertim l'array d'objectes amb les traduccions per a cada idioma en un únic objecte
export const breadcrumbNameMapsMultilingual = breadcrumbNameMapObjArray.reduce((accumulator, currentValue) => Object.assign(accumulator, currentValue), {});
/* export const breadcrumbNameMapsMultilingual = {};
for (let i = 0; i < breadcrumbNameMapObj.length; i++) {
  // breadcrumbNameMapsMultilingual[i] = breadcrumbNameMapObj[i];
  Object.assign(breadcrumbNameMapsMultilingual, breadcrumbNameMapObj[i]);
} */

// IMATGES
export const avatarImage = {
  admin: require('../assets/images/admin.png'),
  clinician: require('../assets/images/clinician.png'),
  patient: require('../assets/images/patient.png'),
  program_configuration_user: require('../assets/images/technical.png'),
};

/* *********************************************************************** */
// RECURSOS GRAFICS A CARREGAR
export const resources = [
  // require('../assets/images/logoHeader.png'),
];

/* CODI DE COLORS */
export const CODE_COLOR = [ // N + 1
  { green: 0, amber: 0, red: 1 }, //  1
  { green: 0, amber: 1, red: 1 }, //  2
  { green: 1, amber: 1, red: 1 }, //  3
  { green: 2, amber: 1, red: 1 }, //  4
  { green: 3, amber: 1, red: 1 }, //  5
  { green: 4, amber: 1, red: 1 }, //  6
  { green: 4, amber: 2, red: 1 }, //  7
  { green: 5, amber: 2, red: 1 }, //  8
  { green: 5, amber: 3, red: 1 }, //  9
  { green: 6, amber: 3, red: 1 }, //  10
  { green: 7, amber: 3, red: 1 }, //  11
  { green: 7, amber: 4, red: 1 }, //  12
  { green: 8, amber: 4, red: 1 }, //  13
  { green: 8, amber: 4, red: 2 }, //  14
  { green: 9, amber: 4, red: 2 }, //  15
  { green: 9, amber: 5, red: 2 }, //  16
  { green: 10, amber: 5, red: 2 }, //  17
  { green: 11, amber: 5, red: 2 }, //  18
  { green: 12, amber: 5, red: 2 }, //  19
  { green: 13, amber: 5, red: 2 }, //  20
  { green: 14, amber: 5, red: 2 }, //  21
  { green: 15, amber: 5, red: 2 }, //  22
  { green: 16, amber: 5, red: 2 }, //  23
  { green: 17, amber: 5, red: 2 }, //  24
  { green: 17, amber: 5, red: 3 }, //  25
  { green: 18, amber: 5, red: 3 }, //  26
  { green: 19, amber: 5, red: 3 }, //  27
  { green: 20, amber: 5, red: 3 }, //  28
  { green: 21, amber: 5, red: 3 }, //  29
  { green: 22, amber: 5, red: 3 }, //  30
  { green: 23, amber: 5, red: 3 }, //  31
  { green: 0, amber: 5, red: 3 }, //  >31 A la darrera posició de l'array posar la configuració per defecte per a la resta de valors d'N
];
